var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeDesktop4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 337 266",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M278.167 77.386C291.098-20 243.281-5.622 174.403 17.052 141.107 30.829 100.499 48.574 18.796 156.07c-102.13 134.37 249.392 133.259 301.161 60.006 56.655-80.166-54.326-44.276-41.79-138.69"
})));
export default SvgShapeDesktop4;